import React, { useEffect } from 'react';
import IvoriMethodPathbuddyPage from '../../features/method/IvoriMethodPathbuddyPage';

export default function IvoriMethodPathbuddyRoute() {
  useEffect(() => {
    document.title = 'The Pathbuddy Method — Reasoning Education | Pathbuddy';
    window.scrollTo(0, 0);
  }, []);

  return <IvoriMethodPathbuddyPage />;
}
